import { Proyect } from './../clases/proyect';
import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Document } from '../clases/document';
import { Constitution } from '../clases/constitution';
import { Bloqueante } from '../clases/bloqueante';

@Injectable({
  providedIn: 'root'
})
export class ProyectService {

  constructor(private readonly http: HttpClient) { }

  public createConstitution(constitution: Constitution, proyectId: number): Observable<any>{
    return this.http.post(environment.backEndHost + environment.serverEndPoint + "/constitucions/" + proyectId, constitution);
  }

  public changeLineProduction(proyectId: number, lineId: number): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/changeLineProduction/" + proyectId + "/" + lineId);
  }

  public getConstitucionById(constitucionId: number): Observable<any> {
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/constitucions/" + constitucionId);
  }

  public updateConstitucion(constitution: Constitution): Observable<any>{
    return this.http.put(environment.backEndHost + environment.serverEndPoint + "/constitucions/" + constitution.id, constitution);
  }

  public updateDocument(document: Document): Observable<any>{
    return this.http.put(environment.backEndHost + environment.serverEndPoint + "/documentacions/" + document.id, document);
  }

  public deleteDocument(documentId: number): Observable<any>{
    return this.http.delete(environment.backEndHost + environment.serverEndPoint + "/documentacions/" + documentId);
  }

  public getAllDocumentsByProyect(page: number, size: number, proyectId: number): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/getByProyect?page=" + (page - 1) + "&size=" + size + "&proyectId=" + proyectId + "&sort=id,desc");
  }

  public deleteBloqueante(bloqueanteId: number): Observable<any>{
    return this.http.delete(environment.backEndHost + environment.serverEndPoint + "/bloqueantes/" + bloqueanteId);
  }

  public createBloqueante(bloqueante: Bloqueante): Observable<any>{
    return this.http.post(environment.backEndHost + environment.serverEndPoint + "/bloqueantes", bloqueante);
  }

  public updateBloqueante(bloqueante: Bloqueante): Observable<any>{
    return this.http.put(environment.backEndHost + environment.serverEndPoint + "/bloqueantes/" + bloqueante.id, bloqueante);
  }

  public getImpactos(): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/impactos");
  }
  public getTipoBloqueando(): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/tipoBloqueantes");
  }
  public getEstadoBloqueando(): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/estadoBloqueantes");
  }


  public getAllBloqueantesByProyect(page: number, size: number, proyectId: number): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/getBloqueantesByProyect?page=" + (page - 1) + "&size=" + size + "&proyectId=" + proyectId + "&sort=id,desc");
  }

  public createDoc(doc: Document): Observable<any>{
    return this.http.post(environment.backEndHost + environment.serverEndPoint + "/documentacions", doc);
  }

  public getAllLines(): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/allLines");
  }

  public getAllEmpleados(): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/empleados-lookup");
  }

  public deleteProyect(proyectId: number): Observable<any>{
    return this.http.delete(environment.backEndHost + environment.serverEndPoint + "/proyectos/" + proyectId);
  }

  public editProyect(proyect: Proyect): Observable<any>{
    return this.http.put(environment.backEndHost + environment.serverEndPoint + "/proyectos/" + proyect.id, proyect);
  }

  public getProyectById(proyectId: number): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/proyectos/" + proyectId);
  }

  public getByOfert(ofertId: number): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/proyectsByOfert?ofertId=" + ofertId);
  }

  public save(proyect: Proyect): Observable<any>{
    return this.http.post(environment.backEndHost + environment.serverEndPoint + "/proyectos", proyect);
  }

  public getEstados(): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/estadosProyect");
  }

  public findLineasDeProduccion(name: string, page: number, size: number): Observable<any>{
    let endPoint: string = "/lineas-produccions?page=" + (page - 1) + "&size=" + size + (name === "" ? "" : "&name=" + name);
    return this.http.get(environment.backEndHost + environment.serverEndPoint + endPoint);
  }

  public getFases(): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/fasesProyect");
  }

  public syncRegistroTiempo(codigo:string): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/sync-registro-clockify/"+codigo);
  }

  public getTotalesRegistro(proyectId: number): Observable<any>{
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/registro-tiempos-totales/" + proyectId);
  }

  public getAllProyectosPage(param: string, estado: string,page: number, size: number): Observable<any>{
    let endPoint: string = "/proyectos-page?page=" + (page - 1) + "&size=" + size + "&sort=id,desc" + (param === "" || param === null ? "" : "&param=" + param)+"&estado="+estado;
    return this.http.get(environment.backEndHost + environment.serverEndPoint + endPoint);
  }

  public getActualCost(proyectId: number): Observable<any>{
    return this.http.get(environment.backEndHost + environment.timeTrackerEndPoint + "/query-registro-tiempos/" + proyectId);
  }



}
